module.exports = __webpack_public_path__ + "00e44cd26103addda63b305090ce97fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_70.jpg
// module id = 1754
// module chunks = 5